import _classCallCheck from '../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import '../../../../node_modules/intersection-observer/intersection-observer.es.js';
import React from 'react';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DivWithIntersectionObserver = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DivWithIntersectionObserver, _React$PureComponent);

  var _super = _createSuper(DivWithIntersectionObserver);

  function DivWithIntersectionObserver() {
    var _this;

    _classCallCheck(this, DivWithIntersectionObserver);

    _this = _super.apply(this, arguments);
    _this.state = {
      isIntersecting: false
    };
    _this._container = /*#__PURE__*/React.createRef();

    _this._handleChange = function (_ref) {
      var isIntersecting = _ref.isIntersecting;
      var onChange = _this.props.onChange;

      _this.setState({
        isIntersecting: isIntersecting
      }, function () {
        if (onChange) {
          onChange({
            isIntersecting: isIntersecting
          });
        }
      });
    };

    return _this;
  }

  _createClass(DivWithIntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var observerOptions = this.props.observerOptions;
      this._observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isIntersecting = entry.isIntersecting;

          if (_this2.state.isIntersecting !== isIntersecting) {
            _this2._handleChange({
              isIntersecting: isIntersecting
            });
          }
        });
      }, observerOptions);

      this._observer.observe(this._container.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._observer) {
        this._observer.disconnect();

        delete this._observer;
      } // this._handleChange.cancel();

    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          style = _this$props.style,
          className = _this$props.className;
      var isIntersecting = this.state.isIntersecting;
      var children = this.props.children;

      if (typeof children === 'function') {
        children = children({
          isIntersecting: isIntersecting
        });
      }

      return /*#__PURE__*/React.createElement("div", Object.assign({
        ref: this._container
      }, {
        id: id,
        style: style,
        className: className
      }), children);
    }
  }]);

  return DivWithIntersectionObserver;
}(React.PureComponent);

export { DivWithIntersectionObserver };
